import { jsx as _jsx } from "react/jsx-runtime";
import { buildCategoryNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { fromUrlIds } from "@faire/retailer-visitor-shared/models/Category/fromUrlIds";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { getCategoryRedirect } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/getCategoryRedirect";
import { LoggedInCategoryPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPage";
import { useLoggedOutCategoryPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/LazyLoggedOutCategoryPage";
import { LoggedOutCategoryPageLoadingSkeleton } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedOutCategoryPageLoadingSkeleton";
import { LazySuppliersPage } from "@faire/retailer-visitor-shared/views/suppliers/LazySuppliersPage";
import { SuppliersPageLoadingSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageLoadingSkeleton";
import { logAssert } from "@faire/web--source/common/logging";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
export var CategoryPageRoot = function(param) {
    var match = param.match, location = param.location;
    var categoryUrlIds = extractCategoryUrlIds(match.params);
    var routingContext = useRetailerRoutingContext();
    var categories = useCategoryStore().categories;
    var category = fromUrlIds(categoryUrlIds, categories !== null && categories !== void 0 ? categories : []);
    var LoggedOutCategoryPage = useLoggedOutCategoryPage();
    logAssert(!!category, "Category creation failed on url, Pathname: ".concat(location.pathname, ". Search: ").concat(location.search));
    var categoryRedirectUrl = getCategoryRedirect(category, {
        match: match,
        location: location
    }, categories !== null && categories !== void 0 ? categories : [], routingContext);
    if (categoryRedirectUrl !== undefined) {
        return /*#__PURE__*/ _jsx(Redirect, {
            to: categoryRedirectUrl
        });
    }
    var mostSpecificPathIdentifier = category.mostSpecificPathIdentifier;
    var _match_params = match.params, brandValue = _match_params.brandValue, c1SuppliersUrlId = _match_params.c1SuppliersUrlId;
    var key = "".concat(mostSpecificPathIdentifier).concat(brandValue).concat(c1SuppliersUrlId);
    var navigationPath = buildCategoryNavigationPath(categoryUrlIds);
    if (isPrerender() || !isLoggedInRetailerOrBrandPreview()) {
        if (!category.mostSpecificCategory.isProductFirstCategory) {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(SuppliersPageLoadingSkeleton, {}),
                children: /*#__PURE__*/ _jsx(LazySuppliersPage, {
                    category: category,
                    navigationPath: navigationPath
                }, key)
            });
        }
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(LoggedOutCategoryPageLoadingSkeleton, {}),
            children: /*#__PURE__*/ _jsx(LoggedOutCategoryPage, {
                category: category,
                navigationPath: navigationPath
            }, key)
        });
    } else {
        return /*#__PURE__*/ _jsx(LoggedInCategoryPage, {
            category: category,
            navigationPath: navigationPath
        }, key);
    }
};
var extractCategoryUrlIds = function(param) {
    var c1CategoryUrlId = param.c1CategoryUrlId, c2CategoryUrlId = param.c2CategoryUrlId, c3CategoryUrlId = param.c3CategoryUrlId, c4CategoryUrlId = param.c4CategoryUrlId, c5CategoryUrlId = param.c5CategoryUrlId, c6CategoryUrlId = param.c6CategoryUrlId, c1SuppliersUrlId = param.c1SuppliersUrlId;
    var _ref;
    return [
        (_ref = c1CategoryUrlId !== null && c1CategoryUrlId !== void 0 ? c1CategoryUrlId : c1SuppliersUrlId) !== null && _ref !== void 0 ? _ref : "",
        c2CategoryUrlId !== null && c2CategoryUrlId !== void 0 ? c2CategoryUrlId : "",
        c3CategoryUrlId !== null && c3CategoryUrlId !== void 0 ? c3CategoryUrlId : "",
        c4CategoryUrlId !== null && c4CategoryUrlId !== void 0 ? c4CategoryUrlId : "",
        c5CategoryUrlId !== null && c5CategoryUrlId !== void 0 ? c5CategoryUrlId : "",
        c6CategoryUrlId !== null && c6CategoryUrlId !== void 0 ? c6CategoryUrlId : ""
    ].filter(function(urlId) {
        return urlId !== "";
    }).map(decodeURIComponent);
};
